import React from "react";
import PropTypes from "prop-types";
import "./_description.scss";

const Description = ({ text }) => {
  return (
    <div className="wizard__description" dangerouslySetInnerHTML={{ __html: text }}>
    </div>
  );
};

Description.propTypes = {
  text: PropTypes.string.isRequired,
};

export default Description;
